<ion-row>
  <ion-col class="inquiry-icons-container">
    <ion-row>
      <ion-col size="4" class="container inquiry-headers-left-container">
        <img src="assets/home-black.svg" alt="home" />
        <div class="sub-header">
          <ion-label class="details-header">
            {{ CONSTANTS.ORIGIN_DETAILS }}
          </ion-label>
          <ion-label class="sub-details-header">
            {{ origAddress }}
          </ion-label>
        </div>
      </ion-col>
      <ion-col size="4">
        <div class="arrow-icon">
          <img src="assets/dot-arrow.svg" alt="arrow" />
        </div>
      </ion-col>
      <ion-col size="4" class="container inquiry-headers-right-container">
        <img src="assets/location-pin.svg" alt="location-pin" />
        <div class="sub-header">
          <ion-label class="details-header">
            {{ CONSTANTS.DESTINATION_DETAILS }}
          </ion-label>
          <ion-label class="sub-details-header">{{ destAddress }} </ion-label>
        </div>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>
